const vue1 = `
&lt;!-- 不建议 -->
&lt;div class="item" @click="toggle(index)" v-for="item,index in list" :key="index">...&lt;/div>

&lt;!-- 建议 -->
&lt;div
    class="item"
    @click="toggle(index)"
    v-for="item,index in list"
    :key="index">
    ...
&lt;/div>
 `
const vue2 = `
&lt;!-- 不建议 -->
&lt;div
    class="item"
    :class="index == itemActive ? 'active' : ''"
    v-for="item,index in list"
    :key="index">
    ...
&lt;/div>

&lt;!-- 建议 -->
&lt;div
    v-show="itemStatus(item)"
    class="item"
    :class="{active: index == itemActive}"
    v-for="item,index in list"
    :key="index">
    ...
&lt;/div>
 `
const vue3 = `
&lt;!-- 不建议 -->
&lt;script>
export default {
    name: '',
    props: { ... },
    components: { ... },
    methods: { ... },
    mounted () { ... },
    destroyed: { ... }
    data () {
        return { ... }
    },
    watch: { ... }
}
&lt;script>

&lt;!-- 建议 -->
&lt;script>
export default {
    name: '',
    components: { ... },
    props: { ... },
    data () {
        return { ... }
    },
    mounted () { ... },
    methods: { ... },
    watch: { ... },
    destroyed: { ... }
}
&lt;script>
 `
const vue4 = `
&lt;script>
export default {
    name: '',
    components: { ... },
    props: { ... },
    data () {
        return { ... }
    },
    ...这里放跟组件生成有关的生命周期函数，比如mounted,
    methods: { ... },
    watch: { ... },
    ...这里放跟组件结束有关的生命周期函数，比如destroyed
}
&lt;script>
 `
const vue5 = `
&lt;my-components />
 `

export default {
    vue1,
    vue2,
    vue3,
    vue4,
    vue5
}